import { fromJS } from 'immutable';

import { createActions } from './actions';

const initialState = fromJS({
  isEditable: false,
  isLoading: false,
});

// eslint-disable-next-line
export const createReducer =
  (key) => {
    const actions = createActions(key);
    return (state = initialState, action) => {
      switch (action.type) {
        case (actions.TOGGLE_EDITABLE.REQUEST):
          return state.set('isEditable', !state.get('isEditable'));

        default:
          return state;
      }
    };
  };
